import _ from 'lodash';
import {FETCH_AI_FUNCTIONS, CLEAN_AI_FUNCTIONS, DELETE_AI_FUNCTION} from './types';
import { request, __ } from '../functions';
import {COOKIE_AI_FUNCTIONS_NAME, COOKIE_SETTINGS} from "../config";

export const fetchAiFunctions = (screen, options = {}) => {
    const { cookies } = screen.props;

    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request('/ai-functions', params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        // Nasetujeme user data
        setUser(sync.user);

        if (!_.isEmpty(sync.user) && _.has(sync.user, 'ai_functions')) {
            // Nastavime
            cookies.set(COOKIE_AI_FUNCTIONS_NAME, sync.user.ai_functions.toString(), COOKIE_SETTINGS);
        }

        dispatch({ type: FETCH_AI_FUNCTIONS, payload: data });
    });
};

export const deleteAiFunction = (screen, id) => {
    return dispatch => request(`/ai-functions/remove/${id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmazať funkciu'));
            return;
        }

        screen.showSnackbar('success', __('Funkcia bola zmazaná'));

        dispatch({ type: DELETE_AI_FUNCTION });
    });
};

export const cleanAiFunctions = () => ({ type: CLEAN_AI_FUNCTIONS });
